window.AppConfig = {
  APP_NAME: "#{appName}#",
  APP_CLIENT_COOKIE_NAME: "#{appClientCookieName}#",
  AUTH_MODE: "#{authMode}#",
  ENVIRONMENT: "#{environment}#",
  API_URL: "#{apiUrl}#",
  PUBLIC_API_URL: "#{publicApiUrl}#",
  PRODUCTS_API_URL: "#{productsApiUrl}#",
  OLD_PORTAL_URL: "#{oldPortalUrl}#",
  LINK_URL: "#{linkUrl}#",
  CONNECTORS_API_URL: "#{connectorsApiUrl}#",
  PORTAL_URL: "#{portalUrl}#",
  IDENTITY_SERVER_URL: "#{identityServerUrl}#",
  USER_MANAGEMENT_URL: "#{userManagementUrl}#",
  USER_MANAGEMENT_API_URL: "#{userManagementApiUrl}#",
  INTEGRATIONS_UI_URL: "#{integrationsUiUrl}#",
  SYNC_HEALTH_UI_URL: "#{syncHealthUiUrl}#",
  ASSESS_UI_URL: "#{assessUiUrl}#",
  AMPLITUDE_API_KEY: "#{amplitudeApiKey}#",
  DATA_HISTORY_UI_URL: "#{dataHistoryUiUrl}#",
  CLIENT_CREDENTIALS_API_URL: "#{clientCredentialsApiUrl}#",
  AUTH0_CLIENTID: "#{auth0ClientId}#",
  AUTH0_DOMAIN: "#{auth0Domain}#",
};

window.SyncHealthConfig = {
  ENVIRONMENT: "#{environment}#",
  API_URL: "#{syncHealthApiUrl}#",
  IDENTITY_SERVER_URL: "#{identityServerUrl}#",
  USER_MANAGEMENT_URL: "#{userManagementUrl}#",
  AMPLITUDE_API_KEY: "#{amplitudeApiKey}#",
  APP_CLIENT_COOKIE_NAME: "#{appClientCookieName}#",
};

window.IntegrationsAppConfig = {
  ENVIRONMENT: "#{environment}#",
  IDENTITY_SERVER_URL: "#{identityServerUrl}#",
  PUBLIC_API_URL: "#{publicApiUrl}#",
  INTEGRATIONS_API_URL: "#{integrationsApiUrl}#",
  PORTAL_API_URL: "#{apiUrl}#",
  CONNECTORS_API_URL: "#{connectorsApiUrl}#",
  CLIENT_CREDENTIALS_API_URL: "#{clientCredentialsApiUrl}#",
  NCINO_API_URL: "#{nCinoApiUrl}#",
  AMPLITUDE_API_KEY: "#{amplitudeApiKey}#",
  FEATURES_API_URL: "#{featuresApiUrl}#",
  USER_MANAGEMENT_URL: "#{userManagementApiUrl}#",
  USER_MANAGEMENT_API_URL: "#{userManagementApiUrl}#",
  APP_CLIENT_COOKIE_NAME: "#{appClientCookieName}#",
  PORTAL_URL: "#{portalUrl}#",
};

window.AssessConfig = {
  PUBLIC_API_URL: "#{publicApiUrl}#",
  IDENTITY_SERVER_URL: "#{identityServerUrl}#",
  APP_CLIENT_COOKIE_NAME: "#{appClientCookieName}#",
  USER_MANAGEMENT_URL: "#{userManagementUrl}#",
  DATA_INTEGRITY_URL: "#{dataIntegrityUrl}#",
  ASSESS_URL: "#{assessUrl}#",
  PRODUCTS_API_URL: "#{productsApiUrl}#",
  ENVIRONMENT: "#{environment}#",
  AMPLITUDE_API_KEY: "#{amplitudeApiKey}#",
  PORTAL_URL: "#{portalUrl}#",
};

window.DataHistoryAppConfig = {
  ENVIRONMENT: "#{environment}#",
  AMPLITUDE_API_KEY: "#{amplitudeApiKey}#",
  PUBLIC_API_URL: "#{publicApiUrl}#",
  IDENTITY_SERVER_URL: "#{identityServerUrl}#",
  USER_MANAGEMENT_URL: "#{userManagementUrl}#",
  APP_CLIENT_COOKIE_NAME: "#{appClientCookieName}#",
};
